import { createRoot } from "react-dom/client";
import { initSentry } from "./lib/sentry";
import { initGA4 } from "./lib/analytics";
import App from "./App";
import "./index.css";

// Initialize Sentry before rendering
initSentry();

// Initialize Google Analytics 4
initGA4();

createRoot(document.getElementById("root")!).render(<App />);
